import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import SearchFilterPopUp from '../searchTippyPopup/searchTippyPopUp'
import moment from 'moment'
import { Button } from 'components/elements'
import { DayPickerRangeController } from 'react-dates'
import isBeforeDay from 'components/elements/dateSelector/airbnbUtils/isBeforeDay'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import { addToUrlPush, removeFromUrlPush } from '../filterUtil.js'
import {
  isStartEndValid,
  START_DATE_SHORT_NAME,
  END_DATE_SHORT_NAME,
  startDateDefault,
  endDateDefault,
} from './datesFilterConfig'
import { setMonthOpen } from 'components/elements/dateSelector/datesSelectorUtil'
import './searchDate.css'
import './../../../theme/assets/styles/updated.sass'

let classNames = require('classnames')

class DateFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      buttonLabel: this.buildButtonLabel(
        this.props.startDate,
        this.props.endDate
      ),
      active: isStartEndValid(this.props.startDate, this.props.endDate)
        ? true
        : false,
      startDate: moment(this.props.startDate).isValid()
        ? moment(this.props.startDate)
        : null,
      endDate: moment(this.props.endDate).isValid()
        ? moment(this.props.endDate)
        : null,
      focusedInput: 'startDate',
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.startDate !== this.props.startDate ||
      prevProps.endDate !== this.props.endDate
    ) {
      this.setState({
        startDate: this.props.startDate,
        endDate: this.props.endDate,
        active: isStartEndValid(this.props.startDate, this.props.endDate)
          ? true
          : false,
        buttonLabel: this.buildButtonLabel(
          this.props.startDate,
          this.props.endDate
        ),
      })
    }
    if (
      prevProps.startDate !== this.props.startDate ||
      prevProps.endDate !== this.props.endDate
    ) {
      this.setState({
        startDate: this.props.startDate,
        endDate: this.props.endDate,
        active: isStartEndValid(this.props.startDate, this.props.endDate)
          ? true
          : false,
        buttonLabel: this.buildButtonLabel(
          this.props.startDate,
          this.props.endDate
        ),
      })
    }
  }

  handleApply = () => {
    const { startDate, endDate } = this.state

    //HEY IDIOT, YOU GOTTA SEND THE  DATES TOGETHER OR THIS DOESn'T WORK WITH SEARCHING.
    //WHEN YOU SEND THEM TOGETHER OR THIS DOESNT'T WORK!!!!!!
    //MAYBE A NEW FUNCTION LIKE: ON DATE APPLY? WHO GIVES A SHIT. JUST DO THAT.
    //SEttinG thIS ACTIVE AND GETTING ISVALIDEDATES TO WORK RIGHT IS NOT WORKINGGGGGGGGGG

    this.closeFilter()
    this.props.onApply(this.state.startDate, this.state.endDate)

    this.setState({
      buttonLabel: this.buildButtonLabel(
        this.state.startDate,
        this.state.endDate
      ),
    })

    if (isStartEndValid(startDate, endDate)) {
      this.setState({ active: true })

      if (this.props.pushToUrl) {
        let valuesToAdd = [
          {
            key: END_DATE_SHORT_NAME,
            value: moment(this.state.endDate).format('YYYY-MM-DD'),
          },
          {
            key: START_DATE_SHORT_NAME,
            value: moment(this.state.startDate).format('YYYY-MM-DD'),
          },
        ]
        let newQueryString = addToUrlPush(
          valuesToAdd,
          this.props.location.search
        )
        this.props.history.push('?' + newQueryString.string)
      }
    } else {
      this.setState({ active: false })
      if (this.props.pushToUrl) {
        let newQueryString = removeFromUrlPush(
          [START_DATE_SHORT_NAME, END_DATE_SHORT_NAME],
          this.props.location.search
        )
        this.props.history.push('?' + newQueryString.string)
      }
    }
  }

  handleOpen = () => {
    this.setState({ open: true })
    this.props.onOpen()
  }

  closeFilter = () => {
    this.setState({ open: false })
    this.props.onClose()
  }

  onDatesChange = (startDate, endDate) => {
    let tempEndDate = endDate ? endDate : startDate
    this.setState({ startDate, endDate: tempEndDate })
  }

  onFocusChange = (focusedInput) => {
    this.setState({
      // Force the focusedInput to always be truthy so that dates are always selectable
      focusedInput: !focusedInput ? 'startDate' : focusedInput,
    })
  }

  buildButtonLabel = (startDate, endDate) => {
    let newButtonLabel = this.props.defaultLabel
    if (startDate && endDate) {
      startDate = moment(startDate)
      endDate = moment(endDate)
      if (startDate.isValid() && endDate.isValid()) {
        newButtonLabel =
          startDate.format('MMM DD') + ' - ' + endDate.format('MMM DD')
      }
    }
    return newButtonLabel
  }

  render() {
    const {
      open,
      buttonLabel,
      active,
      focusedInput,
      startDate,
      endDate,
    } = this.state

    let filterBtnClass = classNames('filterBtnClass', this.props.className, {
      'is-primary': this.props.style === 'old' && (active || open),
      'danger-border': !open && !startDate && !endDate,
    })

    const showDateWarning =
      this.props.showDateWarning && !open && !startDate && !endDate
    const tooltipClass = classNames({
      'has-tooltip-bottom has-tooltip-active has-tooltip-danger has-tooltip-arrow has-multiline-tooltip desktop-search-date-warning-tooltip': showDateWarning,
    })

    const tooltipProps = {
      className: tooltipClass,
    }
    if (showDateWarning) {
      tooltipProps['data-tooltip'] = 'Enter Dates for most accurate pricing'
    }

    return (
      <>
        <SearchFilterPopUp
          triggerClassName={filterBtnClass}
          triggerText={
            <span {...tooltipProps}>
              <span className="icon">
                <i className="far fa-calendar-alt"></i>
              </span>{' '}
              <span>
                {buttonLabel}
              </span>
              <span className="icon mt-1">
                  &nbsp;<i className="fa fa-angle-down"></i>
              </span>
            </span>
          }
          on="click"
          open={open}
          animation={null}
          onClose={() => this.closeFilter()}
          onOpen={() => this.handleOpen()}
        >
          {open && ( //this is a hack to cause the date picker to mount.
            //without this....it just doesn't load. some conflict with popper?
            <>
              <DayPickerRangeController
                onDatesChange={({ startDate, endDate }) =>
                  this.onDatesChange(startDate, endDate)
                }
                noBorder={true}
                onFocusChange={(focusedInput) =>
                  this.onFocusChange(focusedInput)
                }
                isOutsideRange={(day) => isBeforeDay(day, moment())}
                focusedInput={focusedInput}
                startDate={moment(startDate)}
                endDate={moment(endDate)}
                numberOfMonths={2}
                minimumNights={0}
                initialVisibleMonth={() => setMonthOpen()}
                hideKeyboardShortcutsPanel={true}
                showClearDates={true}
              />
              <div
                className="has-text-right search-filter-apply-btn"
                style={{ marginRight: '32px' }}
              >
                <Button onClick={this.handleApply}>Apply</Button>
              </div>
            </>
          )}
        </SearchFilterPopUp>
      </>
    )
  }
}

export default withRouter(DateFilter)

DateFilter.defaultProps = {
  style: 'old',
  startDate: startDateDefault,
  endDate: endDateDefault,
  defaultLabel: 'Dates',
  currentStartDate: startDateDefault,
  currentEndDate: endDateDefault,
  onApply: function() {},
  onOpen: function() {},
  onClose: function() {},
  onClear: function() {},
  pushToUrl: true,
  showDateWarning: true,
}
